// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__WHwdN","div":"sidebar_div__WGtje","text":"sidebar_text__H1b6r","premium":"sidebar_premium__Ly1VL","active":"sidebar_active__YR+6R"};